/**
 * Human-readable age for a queue message or a processing time (YAR-208).
 *
 * The ticket's examples ("42s", "3 min 10s") only cover small values, but the
 * oldest message actually sitting in production `email_processing` is 6.3 days
 * old — "9143 min 11s" is not a number anyone can read. So the ladder keeps
 * going: seconds, minutes, hours, days.
 *
 * NULL renders as "—", never "0s": an empty queue and a message that arrived
 * this instant are different facts.
 */
export function formatAgeSec(sec: number | null): string {
  if (sec === null || !Number.isFinite(sec)) return '—';
  const s = Math.max(0, Math.round(sec));
  if (s < 60) return `${s}s`;
  if (s < 3600) return `${Math.floor(s / 60)} min ${s % 60}s`;
  if (s < 86_400)
    return `${Math.floor(s / 3600)}h ${Math.floor((s % 3600) / 60)}m`;
  return `${Math.floor(s / 86_400)}d ${Math.floor((s % 86_400) / 3600)}h`;
}
